"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalAlert = ModalAlert;
exports.alert = alert;
exports.error = error;
exports.success = success;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.map.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _callBoth = require("../_utils/callBoth");
var _ConfigProvider = _interopRequireDefault(require("../ConfigProvider"));
var _noop = require("../_utils/noop");
var _Button = _interopRequireDefault(require("../Button"));
var _index = _interopRequireDefault(require("./index"));
var _ModalMessage = _interopRequireDefault(require("./ModalMessage"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _excluded = ["onExited"],
  _excluded2 = ["onButtonClick", "onClose"],
  _excluded3 = ["type", "icon", "message", "description"]; // import { mergeRefs } from '../_utils/mergeRefs';
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * API 的方式唤起一个告警对话框
 * @param options
 */
function alert(_ref) {
  var _ref$onExited = _ref.onExited,
    _onExited = _ref$onExited === void 0 ? _noop.noop : _ref$onExited,
    options = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return new Promise(function (resolve) {
    var el = document.createElement('div');
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ConfigProvider.default, {
      classPrefix: options.prefix
    }, /*#__PURE__*/_react.default.createElement(ModalAlertAPI, (0, _extends2.default)({}, options, {
      onButtonClick: function onButtonClick() {
        return resolve();
      },
      onExited: function onExited() {
        _onExited();
        _reactDom.default.unmountComponentAtNode(el);
      }
    }))), el);
  });
}

/**
 * API 的方式唤起一个对话框显示成功信息
 */
function success(options) {
  return alert(_objectSpread({
    type: 'success'
  }, options));
}

/**
 * API 的方式唤起一个对话框显示失败信息
 */
function error(options) {
  return alert(_objectSpread({
    type: 'error'
  }, options));
}
function ModalAlertAPI(_ref2) {
  var onButtonClick = _ref2.onButtonClick,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? _noop.noop : _ref2$onClose,
    modalProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];

  // 渲染之后，马上显示
  (0, _react.useEffect)(function () {
    return setVisible(true);
  }, []);
  var close = function close() {
    onClose();
    setVisible(false);
    onButtonClick();
  };
  return /*#__PURE__*/_react.default.createElement(ModalAlert, (0, _extends2.default)({
    visible: visible,
    onButtonClick: close,
    onClose: close
  }, modalProps));
}

/**
 * 提供原始的 ModalAlert 组件。
 * 推荐使用 `Modal.success()` / `Modal.error()` API 来简化用法
 */
function ModalAlert(_ref3) {
  var type = _ref3.type,
    icon = _ref3.icon,
    message = _ref3.message,
    description = _ref3.description,
    modalProps = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  (0, _react.useEffect)(function () {
    window.focus();
  }, []);
  var getIcons = function getIcons() {
    var icons = {
      error: 'error-24',
      info: 'info-24',
      pending: 'pending-24',
      success: 'success-24',
      warning: 'warning-24'
    };
    if (typeof type === 'string') {
      return icons[type] ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: icons[type]
      }) : null;
    }
    return icon || null;
  };
  return /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    disabledCloseIcon: false
  }, modalProps), /*#__PURE__*/_react.default.createElement(_index.default.Body, null, /*#__PURE__*/_react.default.createElement(_ModalMessage.default, {
    icon: getIcons(),
    message: message,
    description: description
  })), /*#__PURE__*/_react.default.createElement(_index.default.Footer, null, /*#__PURE__*/_react.default.createElement(ModalButton, modalProps)));
}
function ModalButton(_ref4) {
  var buttons = _ref4.buttons,
    buttonText = _ref4.buttonText,
    onButtonClick = _ref4.onButtonClick;
  /* 待 button ref 功能完善后，再添加
  const mainButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (mainButtonRef.current) {
      mainButtonRef.current.focus();
    }
  }, []);
  */

  var okText = buttonText || '确定';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (buttons || [/*#__PURE__*/_react.default.createElement(_Button.default, {
    key: "sure"
  }, okText)]).map(function (button, index) {
    return /*#__PURE__*/_react.default.cloneElement(button, {
      key: index,
      // eslint-disable-line react/no-array-index-key
      onClick: (0, _callBoth.callBoth)(button.props.onClick, onButtonClick)
      // ref: index === 0 ? mergeRefs(button.props.ref, mainButtonRef) : button.props.ref,
    });
  }));
}